import {AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild} from '@angular/core';

@Component({
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss'],
  standalone: true,
})
export class CollapsibleComponent implements AfterViewInit, OnChanges {
  @ViewChild('collapsible', {static: true})
  private readonly collapsibleDiv: ElementRef;

  /* update this to re-trigger the calculation */
  @Input() trackBy: string;

  public collapsed = true;

  public enabled = true;

  ngOnChanges() {
    this.collapsed = true;
    this.enabled = true;
    setTimeout(() => {
      this.checkOverflow();
    }, 0);
  }

  showMore(): void {
    this.collapsed = false;
  }
  showLess(): void {
    this.collapsed = true;
  }

  ngAfterViewInit() {
    this.checkOverflow();
  }

  private checkOverflow(): void {
    const e: any = this.collapsibleDiv.nativeElement;
    if (e.scrollHeight === e.clientHeight) {
      /* smuggle the update past change detection */
      setTimeout(() => {
        this.enabled = false;
      }, 0);
    }
  }
}
